export default {
    components: {},
    data() {
        return {
            second: 0,
            secondText:'获取'
        };
    },
    created() { },
    computed: {
        secondrender() {
            return this.second == 0 ? this.secondText : this.second + 's';
        }
    },
    methods: {
        secondrun() {
            this.second = 60;
            let js = setInterval(() => {
              this.second--;
              if (this.second == 0) {
                clearInterval(js);
              }
            }, 1000);
          },
    },
};